/**
 * Aiello — Ficha Técnica
 * 1) Toggle interno em "Controle e acionamento" (Botão ON/OFF vs Timer Wi-Fi)
 * 2) Accordion exclusivo — só um <details> aberto por vez (fallback pra
 *    browsers que ainda não suportam <details name="...">).
 */
(function () {
  'use strict';

  function initFichaTecnica() {
    var containers = document.querySelectorAll('[data-ft-controle]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (container.__aielloFtInit) return;
      container.__aielloFtInit = true;

      var buttons = container.querySelectorAll('.aiello-ft__inner-btn');
      var contents = container.querySelectorAll('.aiello-ft__inner-content');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var target = btn.getAttribute('data-inner');

          // Atualiza botões
          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          // Atualiza conteúdos
          contents.forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('hidden', '');
          });
          var targetContent = container.querySelector('[data-content="' + target + '"]');
          if (targetContent) {
            targetContent.classList.add('is-active');
            targetContent.removeAttribute('hidden');
          }
        });
      });
    });
  }

  /**
   * Accordion exclusivo — quando um <details> abre, fecha os irmaos
   * que compartilham o mesmo data-ft-acc.
   * Usado data-attr (e nao o atributo "name" nativo) porque o Shopify
   * sanitiza name="" em <details>.
   */
  function initFichaAccordion() {
    var items = document.querySelectorAll('.aiello-ft__item[data-ft-acc]');
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.__aielloFtAccInit) return;
      item.__aielloFtAccInit = true;

      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var group = item.getAttribute('data-ft-acc');
        if (!group) return;
        var siblings = document.querySelectorAll('.aiello-ft__item[data-ft-acc="' + group + '"]');
        siblings.forEach(function (sib) {
          if (sib !== item && sib.open) sib.open = false;
        });
      });
    });
  }

  function init() {
    initFichaTecnica();
    initFichaAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init no Theme Editor
  document.addEventListener('shopify:section:load', init);
})();
